import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { AdminProfile } from "@/core/types";
import { SHORT_LIVED_CACHE } from "@/lib/constants/cache";

import { adminProfileKeys } from "../keyFactory";
import { getAdminProfileById } from "../queryFunctions/getAdminProfileById";

type AdminProfileByIdQueryOptions = UseQueryOptions<
  AdminProfile,
  unknown,
  AdminProfile,
  ReturnType<typeof adminProfileKeys.detailsById>
>;

export function useAdminProfileById(adminId: string, { enabled }: { enabled?: boolean } = {}) {
  return useQuery({
    enabled,
    queryFn: () => getAdminProfileById(adminId),
    queryKey: adminProfileKeys.detailsById(adminId),
    staleTime: SHORT_LIVED_CACHE,
  } satisfies AdminProfileByIdQueryOptions);
}
